import React from "react";
import "./filterHL.css";
import { FilterIcon } from "../../../assets/logos/icons";


const FilterHLPure = (props) => {
  const {
    onFilterChange, //Function change options
    valueItem, //default value from array
    nameOption, //Name value that you use
    options, // Array values
    optionsValue, //Value
    defaultValue
  } = props;

  return (
    <div
      container
      className="filterHLPure-container"
      xs={12}
      lg={12}
      md={12}
      sm={12}
    >
      <div className="filterHLPure-label">
        <img src={FilterIcon} className="filterHLPure-iconFilterStyles" />
      </div>
      <div className="filterHLPure-select-wrapper">
        <select className="filterHLPure-select"
          onChange={onFilterChange}
          defaultValue={defaultValue}
        >
          {options.map((arrayItem, index) => (
            <option
              value={valueItem !== "" ? arrayItem[valueItem] : arrayItem}
              key={index}
              selected={arrayItem[valueItem] === optionsValue ? true : false}
            >
              {arrayItem[nameOption] || arrayItem}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
};

export { FilterHLPure as default };
